<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="login_container">
      <img class="logo" :src="frontLogo" alt=""/>
      <img class="backImg" :src="frontBack" alt=""/>
      <Verify
              @success="success"
              :mode="'pop'"
              :captchaType="'blockPuzzle'"
              :imgSize="{ width: '330px', height: '155px' }"
              ref="verify"
      ></Verify>
      <div class="login_box">
        <!-- 找回密码弹框 -->
        <div v-if="forget_next_yes">
          <div class="mask"></div>
          <div class="tip_box">
            <i class="el-icon-error"></i>
            <div class="tips_info">
              {{ forgetTips }}
            </div>
            <div @click="forget_next_yes = !forget_next_yes" class="tips_btn">
              确认
            </div>
          </div>
        </div>
        <div v-if="forget_next_yes2">
          <div class="mask"></div>
          <div class="tip_box tip_box2">
            <i class="el-icon-error"></i>
            <div class="tips_info2">
              {{ forgetTips2 }}
            </div>
            <div @click="forget_next_yes2 = !forget_next_yes2" class="tips_btn">
              确认
            </div>
          </div>
        </div>
        <!-- 设置新密码弹框 -->
        <div v-if="new_psd_show">
          <div class="mask"></div>
          <div class="new_pws">
            <div>
              <i class="el-icon-success"></i>
              <div>修改成功</div>
            </div>
            <div class="tips_info">{{ new_psd_time }}s 后自动跳转到登录页</div>
          </div>
        </div>
        <div class="login_tit">
          <div>
            {{ login_tit }}
          </div>
          <div v-if="login_show == 2 || login_show == 3">{{ tips }}</div>
        </div>
        <!-- 登录 -->
        <div v-if="login_show == 0" class="login_body">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <div class="level">
              <el-form-item prop="phone">
                <el-input
                  prefix-icon="el-icon-user"
                  placeholder="请输入账号"
                  v-model="ruleForm.phone"
                ></el-input>
              </el-form-item>
            </div>
            <div class="level level2">
              <el-form-item prop="password">
                <el-input
                        type="password"
                        prefix-icon="el-icon-lock"
                        placeholder="请输入密码"
                        v-model="ruleForm.password"
                        @keyup.enter.native="showVerify"
                ></el-input>
                <!-- <div @click="goForget" class="forget">忘记密码 ？</div>     submitForm('ruleForm', 0) -->
              </el-form-item>
            </div>

            <div class="login_btn" @click="showVerify">
<!--            <div class="login_btn" @click="submitForm('ruleForm', 0)">-->
              登&nbsp;录
            </div>
          </el-form>
        </div>
        <!-- 找回密码 -->
        <div v-if="login_show == 1" class="login_body">
          <div class="level">
            <el-input
              prefix-icon="el-icon-user"
              placeholder="请输入您要找回密码的账号"
              v-model="forgetNum"
            ></el-input>
          </div>
          <div class="login_btn" @click="forgetNext">下一步</div>
          <!-- </el-form> -->
        </div>
        <!-- 账号验证 -->
        <div v-if="login_show == 2" class="login_body">
          <el-form
            :model="yanzheng"
            :rules="yanzheng_rules"
            ref="yanzheng_ruleForm"
            class="demo-ruleForm"
          >
            <div class="level">
              <el-form-item>
                <el-input
                  disabled
                  :placeholder="'+86  ' + forgetNum"
                ></el-input>
              </el-form-item>
            </div>
            <div class="level">
              <el-form-item prop="yzm" class="yzm_box">
                <el-input
                  type="password"
                  placeholder="请输入验证码"
                  v-model="yanzheng.yzm"
                ></el-input>
                <button
                  :class="{ yzm_btn_no: disabled2 }"
                  :disabled="disabled2"
                  class="yzm_btn"
                  @click="getYzm"
                >
                  {{ btnTitle }}
                </button>
              </el-form-item>
              <Slider></Slider>
            </div>
            <div @click="submitForm('yanzheng_ruleForm', 2)" class="login_btn">
              下一步
            </div>
          </el-form>
        </div>
        <!-- 设置新密码 -->
        <div v-if="login_show == 3" class="login_body">
          <el-form
            :model="setNewForm"
            :rules="setNewForm_rules"
            ref="setNewForm_ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item prop="pass">
              <el-input
                type="password"
                v-model="setNewForm.pass"
                placeholder="请输入6-12位密码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input
                      type="password"
                      v-model="setNewForm.checkPass"
                      placeholder="请再次输入密码"
                      @keyup.enter="submitForm('setNewForm_ruleForm', 3)"></el-input>
            </el-form-item>
            <div
              @click="submitForm('setNewForm_ruleForm', 3)"
              class="login_btn"
            >
              完成
            </div>
          </el-form>
        </div>

      </div>
    </div>
  </div>

  <!--  <Verify
            @success="success"
            :mode="'pop'"
            :captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"
    ></Verify>-->

</template>
<script>
import store from "store";
import HeaderTop from "@/components/base/headerTop.vue";
import Slider from "@/components/slider.vue";
import {getHeaderTabs, getTabsItem2, getSiteId} from "../../assets/js/api.js";
import Verify from "./../../components/verifition/Verify";
export default {
  name:'login',
  components: {
    HeaderTop,
    Slider,
      Verify
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (value.length < 6 || value.length > 12) {
          // this.$refs.setNewForm.validateField("checkPass");
          callback(new Error("密码长度在6到12位"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.setNewForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
        conheight: {
            height: ''
        },
        loginForm: {
            front:'front',
            siteId:undefined,
            username: '',
            password: ''

        },
      tips: "账号验证",
      // 0登录 1找回密码 2账号验证 3设置新密码
      login_show: 0,
      forget_next_yes: false,
      forget_next_yes2: false,
      forgetNext_show: false,
      new_psd_show: false,
      new_psd_time: "",
      login_tit: "登 录",
      btnTitle: "获取验证码",
      time: "",
      disabled2: false,
      // 登录form
      ruleForm: {
        phone: "",
        yzm: "",
        password: "",
      },
      // 账号验证form
      yanzheng: {
        yzm: "",
      },
      forgetNum: "",
      forgetTips: `您的账号未绑定手机号请联系管理员找回密码`,
      forgetTips2: `账号不存在，请重新输入`,
      // 登录验证规则
      rules: {
        phone: [
          { required: true, message: "请输入账号", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码错误", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      // 验证码验证规则
      yanzheng_rules: {
        yzm: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      // 设置新密码 form
      setNewForm: {
        pass: "",
        checkPass: "",
      },
      // 设置新密码  验证规则
      setNewForm_rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
        frontLogo: undefined,
        frontBack: undefined
    };
  },
    created(){
        this.getSite()
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
    },

    watch: {
        $route: {
            handler: function(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true
        }
    },
    mounted() {

    },
  methods: {
      getHeight() {
          this.conheight.height = window.innerHeight - 40 + 'px';
      },
      getSite() {
          getSiteId(document.domain).then((res) => {
            // getSiteId('smxshglxy.hnzkw.org.cn').then((res) => {

              console.log(res.data)
              console.log(this.frontLogo, "登陆页")
              this.frontLogo = res.data.frontLogo
              this.frontBack = res.data.frontBack

          });
      },

      success(params) {
          this.loginForm.siteId = localStorage.getItem("siteId")
          this.loginForm.username = this.ruleForm.phone
          this.loginForm.password = this.ruleForm.password

          this.$store.dispatch('LoginByUsername', this.loginForm).then((res) => {

              this.$router.push({path: '/index'})
          }).catch(() => {
          });

      },

      showVerify() {
          this.$refs.verify.show()
      },
    // 登录
    submitForm(formName, type) {
      if (!this.ruleForm.phone) {
        this.$message.error("请输入账号！");
        return;
      }
      if (!this.ruleForm.password) {
        this.$message.error("请输入密码！");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 登录
          if (type == 0) {
              this.loginForm.siteId = localStorage.getItem("siteId")
              this.loginForm.username = this.ruleForm.phone
              this.loginForm.password = this.ruleForm.password

              this.$store.dispatch('LoginByUsername',this.loginForm).then((res)=>{

                  this.$router.push({ path: '/index' })
              }).catch(()=>{

              })
          } else if (type == 2) {
            // 账号验证
            console.log("账号验证成功");
            this.login_show = 3;
            this.tips = "设置新密码";
          } else if (type == 3) {
            // 设置新密码
            console.log("设置新密码成功");
            this.new_psd_show = true;
            this.new_psd_time = 3;
            this.timer2 = setInterval(() => {
              if (this.new_psd_time == 0) {
                clearInterval(this.timer2);
                this.new_psd_show = false;
                this.login_show = 0;
                this.login_tit = "登录";
              } else {
                this.new_psd_time--;
                console.log(this.new_psd_time);
              }
            }, 1000);
          }
        } else {
          if (type == 0) {
            console.log("登录失败");
            this.$message.error(res.msg);
            return;
          } else if (type == 2) {
            // 账号验证
            console.log("账号验证失败");
          } else if (type == 3) {
            // 设置新密码
            console.log("设置新密码失败");
          }
          return false;
        }
      });
    },
    goForget() {
      this.login_show = 1;
      this.login_tit = "找回密码";
    },
    // 下一步
    forgetNext() {
      if (!this.forgetNum) {
        this.forget_next_yes = !this.forget_next_yes;
        // this.forget_next_yes2 = !this.forget_next_yes2;
      } else {
        this.login_show = 2;
      }
    },
    // 获取验证码
    getYzm() {
      this.time = 60;
      this.timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(this.timer);
          this.btnTitle = "获取验证码";
          this.disabled2 = false;
        } else {
          this.btnTitle = this.time + "秒后重试";
          // this.btnTitle = "获取验证码" + "(" + this.time + ")";
          this.disabled2 = true;
          this.time--;
        }
      }, 1000);
    },
    // 账号验证  下一步
    // submitForm2(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       console.log("成功");
    //       this.login_show = 3;
    //       this.tips = "设置新密码";
    //     } else {
    //       console.log("登录失败");
    //       return false;
    //     }
    //   });
    // },
    // 设置新密码 下一步
    // submitForm3(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert("submit!");
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
  },
};
</script>
<style lang="less">
@deep: ~">>>";
input::-webkit-input-placeholder {
  color: #999;
  font-size: 14px;
}
@deep: ~">>>";
input::-moz-input-placeholder {
  color: #999;
  font-size: 14px;
}
@deep: ~">>>";
input::-ms-input-placeholder {
  color: #999;
  font-size: 14px;
}
@deep: ~">>>";
.el-input__icon {
  font-size: 22px;
  color: #4195f2;
}
.el-input--prefix .el-input__inner {
  padding-left: 40px;
  height: 44px;
}
.el-form-item__content {
  margin-left: 0 !important;
}
// .level2 {
//   .el-form-item__error {
//     top: 60%;
//   }
// }
.login_container {
  width: 100%;
  justify-content: space-between;
  min-height: calc(100vh - 200px);
  .logo {
    margin-top: 20px;
    margin-left: 200px;
    width: 35%;
    height: 75px;
  }
  // background: linear-gradient(90deg, #aac9d8 0%, #278dff 100%);
  /*background: url(../../assets/img/login/bg.png) no-repeat;*/
    background-size: cover;
  .backImg {
    width: 100%;
    //height: 655px;
    height: 100%;
    //min-height: calc(100vh - 100px);
  }
  .login_box {
    position: absolute;
    top: 45%;
    left: 65%;
    transform: translateY(-50%);
    //width: 20%;
    //height: 40%;
    width: 380px;
    height: 380px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .login_tit {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 53px;
      line-height: 45px;
      border-bottom: 1px solid #cacaca;
      padding: 0 20px;
      padding-top: 5px;
      box-sizing: border-box;
      div:nth-child(1) {
        font-size: 20px;
        color: #4195f2;
      }
      div:nth-child(2) {
        font-size: 14px;
        color: #4296f2;
      }
    }
    .login_body {
      padding: 25px;
      box-sizing: border-box;
      .level {
        margin-bottom: 10%;
        .forget {
          font-size: 12px;
          color: #4296f2;
          float: right;
          cursor: pointer;
        }
        .yzm_box {
          position: relative;
          // display: flex;
          .yzm_btn {
            position: absolute;
            top: 50%;
            right: 15px;
            height: 90%;
            transform: translateY(-50%);
            color: #4296f2;
            font-size: 14px;
            border: none;
            background-color: #fff;
            cursor: pointer;
          }
        }
      }
      .login_btn {
        position: absolute;
        left: 50%;
        bottom: 30px;
        transform: translate(-50%);
        width: 80%;
        height: 12%;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 20px;
        background-color: #4195f2;
        border-radius: 25px;
        cursor: pointer;
      }
      .yzm_btn_no {
        cursor: not-allowed !important;
      }
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      z-index: 1;
    }
    .tip_box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      width: 200px;
      height: 150px;
      background-color: #fff;
      border-radius: 10px;
      padding: 15px 20px;
      box-sizing: border-box;
      text-align: center;
      .el-icon-error {
        color: #e7201a;
        font-size: 30px;
      }
      .tips_info {
        width: 140px;
        margin: 10px auto;
        line-height: 1.5;
      }
      .tips_info2 {
        width: 160px;
        margin: 10px auto;
        line-height: 1.5;
      }
      .tips_btn {
        font-size: 16px;
        color: #4296f2;
        text-align: center;
        height: 37px;
        line-height: 37px;
        border-top: 1px solid #eaeaea;
        cursor: pointer;
      }
    }
    .tip_box2 {
      height: 130px;
    }
    .new_pws {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      width: 200px;
      height: 82px;
      background-color: #fff;
      border-radius: 10px;
      text-align: center;
      padding-top: 15px;
      box-sizing: border-box;
      > div:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: center;
        .el-icon-success {
          font-size: 28px;
          color: #4195f2;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          color: #000;
        }
      }

      > div:nth-child(2) {
        color: #4195f2;
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
}
</style>
